/**
 * DreamPay Private API
 * Private API v2 - Current version with JWT authentication, role-based access control, and enhanced security features.
 *
 * The version of the OpenAPI document: v2
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PaymentLinkDTOV2 {
  id?: string;
  establishmentId?: number;
  establishmentName?: string;
  value?: number;
  customerEmail: string;
  orderNumber?: string;
  observations?: string;
  paid?: boolean;
  paidToEstablishment?: boolean | null;
  customerName?: string;
  date?: string | null;
  link?: string;
  expired?: boolean;
  canceled?: boolean;
  callbackUrl?: string | null;
  currencyCode?: string;
  customerPhoneNumber?: string | null;
  qrcodeUrl?: string | null;
  returnUrl?: string | null;
  formHeaderHtml?: string | null;
  formFooterHtml?: string | null;
  linkType?: number;
  establishmentSupportsFinancingCosts?: boolean | null;
  pdfUrl?: string;
}
